import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import SimpleModal from '../SimpleModal';
import { BASIC_EDITOR_TOOLBAR_EVENT } from '../../dashboard/basicEditorToolbar';
import { useToast } from '../../context/ToastContext';
import { dashboardPageKeyFromPathname } from '../../lib/dashboardPath';

export default function ShowOnlyDuplicatesModal({
  show,
  onClose,
}: {
  show: boolean;
  onClose: () => void;
}) {
  const { pathname } = useLocation();
  const { showToast } = useToast();
  const [duplicateBy, setDuplicateBy] = useState<'url' | 'name'>('url');

  function apply() {
    if (dashboardPageKeyFromPathname(pathname) !== 'channel-basic') {
      showToast('Open Basic editor (Channels) to filter duplicates.', 'info');
      onClose();
      return;
    }
    window.dispatchEvent(
      new CustomEvent(BASIC_EDITOR_TOOLBAR_EVENT, {
        detail: { command: 'filter-duplicates', duplicateBy },
      }),
    );
    onClose();
  }

  return (
    <SimpleModal
      show={show}
      onClose={onClose}
      title="Show only duplicates"
      size="sm"
      modalId="showOnlyDuplicatesModal"
      footer={
        <div className="d-flex justify-content-end w-100">
          <button type="button" className="btn btn-default" onClick={apply}>
            Save
          </button>
        </div>
      }
    >
      <label className="form-label">Filter by:</label>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="duplicate-filter"
          id="dupFilterUrl"
          checked={duplicateBy === 'url'}
          onChange={() => setDuplicateBy('url')}
        />
        <label className="form-check-label" htmlFor="dupFilterUrl">
          Url
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="duplicate-filter"
          id="dupFilterName"
          checked={duplicateBy === 'name'}
          onChange={() => setDuplicateBy('name')}
        />
        <label className="form-check-label" htmlFor="dupFilterName">
          Name
        </label>
      </div>
    </SimpleModal>
  );
}
